import Swiper from 'swiper';

new Swiper(' .imageslider.swiper-container', {
  loop: true,
  speed: 200,
  spaceBetween: 0,
  autoplay: {
    delay: 5000,
  },
  simulateTouch: false,

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

new Swiper('.swiper-container', {
  loop: true,
  speed: 500,
  spaceBetween: 0,
  autoplay: {
    delay: 8000,
  },
  simulateTouch: false,

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
